import { render, staticRenderFns } from "./PreschoolEnglish1.vue?vue&type=template&id=5c9bd9a5&scoped=true&"
import script from "./PreschoolEnglish1.vue?vue&type=script&lang=js&"
export * from "./PreschoolEnglish1.vue?vue&type=script&lang=js&"
import style0 from "@/assets/hometeacher/css/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./PreschoolEnglish1.vue?vue&type=style&index=1&id=5c9bd9a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9bd9a5",
  null
  
)

export default component.exports